/*
 * Sticky mobile "Add to cart" bar.
 *
 * Shows the bar once the real Add to cart button (data-product-atc) has
 * scrolled out of view, hides it again once that button is back in view.
 * The bar's own button just proxies a click to the real one, so it reuses
 * whatever AJAX add-to-cart handling the theme already has wired up
 * instead of re-implementing it.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('[data-sticky-atc]');
    var realButton = document.querySelector('[data-product-atc]');
    var proxyButton = document.querySelector('[data-sticky-atc-button]');

    if (!bar || !realButton || !proxyButton) {
      return;
    }

    proxyButton.addEventListener('click', function () {
      if (realButton.disabled) {
        return;
      }
      realButton.click();
    });

    if (typeof window.IntersectionObserver === 'function') {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      observer.observe(realButton);
      bar.hidden = false;
    }
  });
})();
